// A scan has readings when its rawData array is non-empty. Scans with no
// readings render as a minimal empty-state card (photo + date only).
export function hasReadings(rawData) {
    return rawData.length > 0;
}
// Rounded mean hydration across all regions, or null when there are no readings.
export function averageHydration(rawData) {
    if (rawData.length === 0)
        return null;
    const sum = rawData.reduce((acc, r) => acc + r.hydration, 0);
    return Math.round(sum / rawData.length);
}
// Local calendar date key ('YYYY-MM-DD') for an ISO timestamp. Local, not UTC,
// so a scan reads under the day the admin sees it (design: "local calendar date").
function localDateKey(d) {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
// Group a user's scans by capture date into morning/evening windows, newest date
// first. A scan that cannot be placed — null/invalid `takenAt`, or a `scanWindow`
// that is not 'morning'/'evening' — is collected into `unplaced` rather than
// silently dropped. On a same-window/same-day collision the most recent wins.
export function groupScansByDayNight(scans) {
    const byDate = new Map();
    const unplaced = [];
    for (const scan of scans) {
        const window = scan.scanWindow;
        const when = scan.takenAt ? new Date(scan.takenAt) : null;
        const placeable = when !== null &&
            !Number.isNaN(when.getTime()) &&
            (window === 'morning' || window === 'evening');
        if (!placeable) {
            unplaced.push(scan);
            continue;
        }
        const key = localDateKey(when);
        const day = byDate.get(key) ?? { date: key };
        const existing = window === 'morning' ? day.morning : day.evening;
        // Keep the most recent scan when two land in the same window on the same day.
        if (!existing || new Date(existing.takenAt) < when) {
            day[window] = scan;
        }
        byDate.set(key, day);
    }
    // Date keys are 'YYYY-MM-DD', so lexical descending === chronological newest-first.
    const days = [...byDate.values()].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
    return { days, unplaced };
}
